import { Menu } from "lucide-react";
import { useDispatch } from "react-redux";
import { toggleMenu } from "../store/state/MenuState";

const Hamburger = () => {
  const dispatch = useDispatch();

  function handleClick() {
    dispatch(toggleMenu());
  }

  return (
    <>
      <button onClick={handleClick} className="hidden">
        <Menu color="#6F6D7C" />
      </button>
    </>
  );
};

export default Hamburger;
